// extracted by mini-css-extract-plugin
export default {"loadingSkeletonContainer":"FormElementLoading-module__loadingSkeletonContainer--SsH3H"};